// extracted by mini-css-extract-plugin
export default {"dialog":"CheckYourDeviceDialog_dialog__5-QP0","icon":"CheckYourDeviceDialog_icon__nwXJx","buttons":"CheckYourDeviceDialog_buttons__As3ue"};